import {PoliticsContainer} from '../containers/Documents/PoliticsContainer'

export const Politics = () => (
    <>
        <PoliticsContainer />
    </>
)